// @flow
import type { State } from "@store/reducers";

export const selectAppAdoptionHighlights = (state: Object) => {
  return state.service.appAdoption.highlights;
};

export const selectAppAdoptionDepartments = (state: Object) => {
  return state.service.appAdoption.departments;
};
